import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Gable — the PayHOA AI assistant mark: a Phosphor robot glyph on a
 * blue→indigo gradient disc. Sized via the `size` input or the `--gable-size`
 * CSS custom property on the host.
 */
@Component({
    selector: 'app-ai-gable-mascot',
    templateUrl: './ai-gable-mascot.component.html',
    styleUrls: ['./ai-gable-mascot.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class AiGableMascotComponent {
    /** Square size in px. Default 28. */
    @Input() size = 28;

    /** When true, a little thought-bubble cluster pops above his head. */
    @Input() thinking = false;

    /** Per-instance so multiple marks on one page don't share a gradient def. */
    readonly gradientId = `gable-grad-${AiGableMascotComponent.nextId++}`;

    private static nextId = 0;

    @HostBinding('style.--gable-size.px') get hostSize(): number {
        return this.size;
    }

    @HostBinding('class.is-thinking') get hostThinking(): boolean {
        return this.thinking;
    }

    /**
     * Backward-compat no-op. The page-load easter-egg reactions were
     * pulled until we have time to design them properly; callers in
     * the drawer host still reference this method, so keep it as a
     * stub to avoid a compile break when the feature comes back.
     */
    playRandomReaction(): void {
        // Intentionally empty.
    }
}
